export default __webpack_public_path__ + "static/media/img (1).e52d9129.jpg";